export default __webpack_public_path__ + "static/media/ido.cc446684.png";